import { render } from "./Organisation.vue?vue&type=template&id=2ae55ef7"
import script from "./Organisation.vue?vue&type=script&lang=js"
export * from "./Organisation.vue?vue&type=script&lang=js"

import "./Organisation.vue?vue&type=style&index=0&id=2ae55ef7&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__